<template>
  <div>
     <Card>
    <i-button type="primary"
              @click="addSpec">
      <common-icon type="md-add" />{{$t('pages_combo_rule_list_290')}}
      </i-button>
    <Modal v-model="editing"
           :title="$t('pages_wechat_product_specs_index_1216')"
           :footer-hide="true">
      <i-form>
        <form-item :label-width="100"
                   prop="name"
                   :label="$t('pages_wechat_product_specs_index_1217')">
          <i-input v-model="editRow.name" />
        </form-item>
        <form-item :label-width="100"
                   prop="sequence"
                   :label="$t('pages_mall_groups_index_609')"><i-input v-model="editRow.sequence" />
        </form-item>
        <form-item class="t-c">
          <i-button @click="editing=false">{{$t('pages_city_shop_freights_index_250')}}</i-button>
          <i-button type="primary"
                    @click="saveSpec"
                    class="m-l-12">{{$t('pages_products_edit_831')}}</i-button>
        </form-item>
      </i-form>
    </Modal>
    <col :span="24">
    <i-table ref="table"
             :highlight-row="true"
             :columns="columns"
             :data="specs">
      <template slot="action"
                slot-scope="{ row }">
        <i-button type="primary"
                  @click="editSpec(row)">{{$t('pages_deduct_coupon_rule_components_scopeofuse_index_449')}}</i-button>
        <i-button type="warning"
                  @click="removeSpec(row.id)"
                  class="m-l-12">{{$t('libs_table_render_70')}}</i-button>
        <i-button class="m-l-12"
                  @click="changeCurrent(row)">{{$t('pages_wechat_product_specs_index_1218')}}</i-button>
      </template>
    </i-table>
    <drawer width="500"
            v-model="showProperties"
            :mask="false"
            :mask-closable="false"
            @on-close="onDrawClose">
      <template slot="header">
        <Row>
          <Col span="20">{{$t('pages_wechat_product_specs_index_1219', [ (selected && selected.name) ])}}</Col>
          <Col span="4">
          <i-button type="primary"
                    @click="addProperty">{{$t('pages_combo_rule_list_290')}}</i-button>
          </Col>
        </Row>
      </template>
      <row class="m-t-12"
           :gutter="4"
           v-for="(item, index) in properties"
           :key="index">
        <Col span="16">
        <i-input v-model="properties[index].name" />
        </Col>
        <col span="4">
        <i-button size="default"
                  type="primary"
                  class="m-l-12"
                  ghost
                  @click="onSaveProperty(item)">{{$t('pages_products_edit_831')}}</i-button>
        <i-button size="default"
                  type="warning"
                  v-if="item.id"
                  class="m-l-12"
                  @click="onRemoveProperty(item)">{{$t('libs_table_render_70')}}</i-button>
        </col>
      </row>
      <span slot="close"></span>
      <div style="position: fixed; bottom: 0;height: 200px; line-height: 200px;text-align: center;right:0;width: 500px;">
        <i-button @click="onDrawClose"
                  type="default">{{$t('pages_birthday_discount_index_209')}}</i-button>
      </div>
    </drawer>
    </col>
     </Card>
</div>
</template>

<script>
import i18n from "../../locales/index";

/* eslint-disable */
import CommonIcon from "_c/common-icon";
import { mapActions, mapState } from "vuex";
export default {
  name: "Specs",
  components: {
    CommonIcon,
  },
  data() {
    const self = this;
    return {
      editing: false,
      editRow: {},
      specs: [],
      selected: null,
      showProperties: false,
      properties: [],
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "name",
          title: i18n.t("pages_wechat_product_specs_index_1220"),
        },
        {
          key: "sequence",
          title: i18n.t("pages_mall_groups_index_609"),
        },
        {
          key: "id",
          title: i18n.t("pages_ai_image_163"),
          slot: "action",
        },
      ],
    };
  },
  computed: {
    ...mapState("mall_property_name", [
      "mall_property_name",
      "mall_property_names",
      "meta",
      "loading",
    ]),
    ...mapState("mall_property_value", {
      propertyValue: "mall_property_value",
      propertyValues: "mall_property_values",
      peopertyMeta: "meta",
    }),
  },
  watch: {
    mall_property_names: {
      immediate: true,
      handler(value) {
        this.specs = value;
      },
    },
    propertyValues: {
      immediate: true,
      handler(value) {
        this.properties = value;
      },
    },
  },
  methods: {
    ...mapActions("mall_property_name", [
      "index",
      "create",
      "update",
      "destroy",
    ]),
    ...mapActions("mall_property_value", {
      getPropertyValues: "index",
      createProperty: "create",
      updateProperty: "update",
      removeProperty: "destroy",
    }),
    addSpec() {
      this.editing = true;
      this.editRow = {};
    },
    editSpec(row) {
      this.editRow = { ...row };
      this.editing = true;
    },
    async removeSpec(id) {
      await this.destroy(id);
      await this.index({ page: this.meta.page, per: 999 });
    },
    async saveSpec(index) {
      const row = this.editRow;
      const payload = { name: row.name, sequence: row.sequence };
      try {
        if (row.id) {
          await this.update({ ...payload, id: row.id, sequence: row.sequence });
        } else {
          await this.create(payload);
        }
        this.index({ page: this.meta.page, per: 999 });
        this.editing = false;
      } catch (e) {
        this.$message.error(i18n.t("pages_wechat_product_specs_index_1221"));
      }
    },
    changeCurrent(spec) {
      if (spec) {
        this.showProperties = true;
        this.selected = spec;
        this.getPropertyValues({ mall_property_name_id: spec.id,  per:999 });
      } else {
        this.selected = null;
      }
    },
    onDrawClose() {
      this.showProperties = false;
      this.$refs.table.clearCurrentRow();
    },
    addProperty() {
      this.properties.push({
        name: "",
        id: null,
      });
    },
    async onSaveProperty(row) {
      if (!row.id) {
        this.createProperty({
          mall_property_name_id: this.selected.id,
          name: row.name,
        });
      } else {
        this.updateProperty({
          ...row,
          mall_property_name_id: this.selected.id,
        });
      }
      if (this.selected) {
        await this.getPropertyValues({
          mall_property_name_id: this.selected.id,
          per:999
        });
      }
    },
    async onRemoveProperty(row) {
      await this.removeProperty(row.id);
      if (this.selected) {
        await this.getPropertyValues({
          mall_property_name_id: this.selected.id,
          per:999
        });
      }
    },
  },
  mounted() {
    this.index({
      per:999
    });
  },
};
</script>

<style lang="less">
.spec_handlers {
  > button {
    margin-right: 4px;
  }
}
</style>
